import React from 'react';
import { NavLink } from 'react-router-dom'

import './Navbar.scss';
import { getUrlPath } from '../../utils';

export function Navbar(props) {
    const { apis, showUserGuides, showProductManuals, showStormForDevices, showStormForAtlas } = props;

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="logo">
                <NavLink to="/" className="logo-storm">Storm <span className="heading">Documentation</span></NavLink>
            </div>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                {showStormForDevices && showStormForAtlas && (
                    <ul className="navbar-nav mr-auto atlas-gas-buttons">
                        <li className="nav-item">
                            <NavLink to="/api-reference" className="nav-link" activeClassName='active-menu-item'>
                                Atlas Meters
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/devices" className="nav-link" activeClassName='active-menu-item'>
                                Gas Meters
                            </NavLink>
                        </li>
                    </ul>
                )}
                <ul className="navbar-nav ml-auto">
                    {showUserGuides && (
                        <li className="nav-item active">
                            <NavLink to="/user-guides" className="nav-link" activeClassName='active-menu-item'>
                                User Guides
                            </NavLink>
                        </li>
                    )}
                    {showProductManuals && (
                        <li className="nav-item">
                            <NavLink to="/product-manuals" className="nav-link" activeClassName='active-menu-item'>
                                Product Manuals
                            </NavLink>
                        </li>
                    )}
                    {showStormForAtlas && (
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                API Reference
                            </a>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                {apis.map((api, i) =>
                                    <NavLink to={`/api-reference/${getUrlPath(api.name)}`}
                                        className="dropdown-item"
                                        activeClassName='active-api'
                                        key={i}>{api.name}
                                    </NavLink >
                                )}
                            </div>
                        </li>
                    )}
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;